import axios from 'axios';

/**
 * Upload an image File or Blob to ImgBB
 *
 * ImgBB API Endpoint: https://api.imgbb.com/1/upload?key={API_KEY}
 * Accepts FormData with 'image' field (Blob or base64)
 */

export async function uploadToImgbb(imageBlob, customApiKey = null) {
  const apiKey =
    customApiKey ||
    process.env.REACT_APP_IMGBB_API_KEY ||
    localStorage.getItem('imgbb_api_key');

  if (!apiKey || !apiKey.trim()) {
    throw new Error(
      'ImgBB API Key is required. Please provide a free ImgBB API key from https://api.imgbb.com/'
    );
  }

  const formData = new FormData();
  formData.append('image', imageBlob);

  try {
    const response = await axios.post(
      `https://api.imgbb.com/1/upload?key=${encodeURIComponent(apiKey.trim())}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.data && response.data.success) {
      return {
        url: response.data.data.url,
        displayUrl: response.data.data.display_url,
        thumbUrl: response.data.data.thumb?.url,
        deleteUrl: response.data.data.delete_url,
        data: response.data.data,
      };
    } else {
      throw new Error(response.data?.error?.message || 'ImgBB upload failed');
    }
  } catch (error) {
    const errorMsg =
      error.response?.data?.error?.message ||
      error.message ||
      'Failed to upload image to ImgBB';
    throw new Error(errorMsg);
  }
}
